// extracted by mini-css-extract-plugin
module.exports = {"banner":"style_banner__1ZcoU","message":"style_message__bTTGS","cta":"style_cta__T8nBm","dismissBtn":"style_dismissBtn__uqHRX"};